import Image from 'next/image'

import { useContactInfo } from '@/api/models/common/hooks/useContactInfo'
import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { CallButton } from '@/components/shared/button/ui/CallButton'
import { formatPhoneNumber, makePhoneCallable } from '@/utils/number'

export const UnavailableParkingScreen = () => {
  const { data: contactInfo, hasContactInfo } = useContactInfo()

  const { breakpoint } = useCurrentBreakpoint()

  const isMobileScreen = [ScreenSize.Xxs].includes(breakpoint)

  return (
    <div className="mb-40 flex h-full flex-col items-center justify-between xl:px-0 lg:px-16">
      <div className="mt-[100px] flex flex-col items-center">
        <Image
          src="/images/passes/Parking.png"
          width={isMobileScreen ? 89 : 180}
          height={isMobileScreen ? 89 : 180}
          alt="parking-image"
        />
        <strong className="mb-8 mt-20 text-28 xxs:text-20">
          Аренда паркинга недоступна
        </strong>
        <p className="text-center text-grey-60 text-20 xxs:text-16">
          К сожалению, аренда паркинга недоступна в данный момент. Попробуйте
          позже
          {hasContactInfo && (
            <>
              {' '}
              или обратитесь в Службу комфорта Sminex
              {contactInfo?.contactPhone && (
                <>
                  {' '}
                  по номеру{' '}
                  <a
                    className="text-bronze-40 text-20 xxs:text-16"
                    href={`tel:${makePhoneCallable(contactInfo.contactPhone)}`}
                  >
                    {formatPhoneNumber(contactInfo.contactPhone)}
                  </a>
                </>
              )}
              {contactInfo?.contactEmail && (
                <>
                  {' '}
                  или напишите на{' '}
                  <a
                    className="text-bronze-40 text-20 xxs:text-16"
                    href={`mailto:${contactInfo.contactEmail}`}
                  >
                    {contactInfo.contactEmail}
                  </a>
                </>
              )}
            </>
          )}
          .
        </p>
      </div>
      <CallButton />
    </div>
  )
}
